import api from "../api";

export const getUser = async (id: string) => {
  try {
    const token = localStorage.getItem("token");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    const res = await api.get(`/users/${id}`);
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
